/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

// testing environments
const nonProductionEnvs = ['localhost', 'dev', 'qa', 'sandbox'];

/**
 * Checks if the current environment is a production one
 * @returns {boolean}
 */
export const isProdOrDemoEnvironment = () => !nonProductionEnvs.some(v => window.location.href.includes(v));

/**
 * Adds 'data-testid' attribute for any non-productive environment
 * @param value - 'data-testid' to be added
 * @returns {{}} - object containing 'data-testid' attribute
 */
export const dataTestId = ({ value }) => ({
  ...(!isProdOrDemoEnvironment() && { 'data-testid': value }),
});
